import { z } from "zod";

export const patchIncomingInvoiceDeliveryNoteParamsSchema = z.object({
	deliveryNoteId: z.string().min(1),
});

export type PatchIncomingInvoiceDeliveryNoteParamsSchema = z.infer<
	typeof patchIncomingInvoiceDeliveryNoteParamsSchema
>;
